import { BoundedContent, Li, Link } from '@vp/swan'
import { getHeaderTracker } from '../../../../tracking'
import { TOP_NAV } from '../../../../constants/analytics'
import { ComponentType } from '../../../../types/components-map'

const capitalizedTextLocales = ['de-de', 'de-at', 'de-ch']

type SeeAllLinkProps = {
  seeAllText?: string
  seeAllUrl?: string
  parentNavigationDetailPath?: string[]
  seeAllAnalyticsId?: string
}

export default function SeeAllLink(props: SeeAllLinkProps) {
  const { seeAllText, seeAllUrl, parentNavigationDetailPath, seeAllAnalyticsId } = props
  const navigationDetailPath = seeAllAnalyticsId && parentNavigationDetailPath ? parentNavigationDetailPath.concat(seeAllAnalyticsId) : []

  const handleTracking = () =>
    getHeaderTracker().trackLink({
      subSection: TOP_NAV,
      navigationDetailPath,
      href: seeAllUrl,
    })

  const handleKeyDown = (e: React.KeyboardEvent<HTMLAnchorElement>) => {
    if (['Enter', ' '].includes(e.key)) {
      handleTracking()
    }
  }

  if (!seeAllText || !seeAllUrl) return null

  return (
    <Li backgroundColor="strong">
      <BoundedContent py={7} px={8}>
        <Link
          href={seeAllUrl}
          onClick={handleTracking}
          onKeyDown={handleKeyDown}
          skin="unstyled"
          fontSkin="body-standard-bold"
          style={{ textTransform: capitalizedTextLocales.includes(navigator.language.toLowerCase()) ? 'capitalize' : 'none' }}
          data-position={0}
          data-translation={navigationDetailPath.join('|')}
          data-section={`${ComponentType.HEADER}:${TOP_NAV}`}
        >
          {seeAllText}
        </Link>
      </BoundedContent>
    </Li>
  )
}
